// «Zobacz w środku»: real pages from JUDO GOTOWE™ Tom 1 (Gamma Estudio) ONLY.
// WebP 1512×1890 uploaded to Higgsfield (cloudfront). Copies: judo-gotowe/landing/zobacz/.
const CDN = 'https://d2ol7oe51mr4n9.cloudfront.net/user_37MCUZnyYhEzEhcHxirwYMezT12/';
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    src: CDN + '978750bc-8df2-4b35-8082-511c2b7e3536.webp',
    label: 'Tom 1 · Okładka',
    title: 'Plan roczny i 12 gotowych zajęć minuta po minucie',
    text: 'Trener z grupą dzieci ćwiczy ukemi na tatami. Od razu widać, co dostajesz: 4–15 lat, 3 grupy wiekowe, 3 poziomy, karty do druku, testy i ocena.'
  },
  {
    src: CDN + '50c08631-4d58-4fd4-8c6a-17c5d05ae99b.webp',
    label: 'Tom 1 · Plan roczny',
    title: 'Przedszkolaki 4–6 lat: od września do czerwca',
    text: 'Każdy miesiąc ma blok, cel i wydarzenie: od „Witamy na macie” i bezpiecznych upadków, przez kesa-gatame i równowagę, po egzamin na belkę i pokaz dla rodziców.'
  },
  {
    src: CDN + '011005ad-57ba-47f0-8012-c1961914189b.webp',
    label: 'Tom 1 · Strona trenera',
    title: 'Zajęcia 5 · Ukemi od podstaw (7–10 lat, 60 min)',
    text: 'Minuta po minucie: powitanie i rei, rozgrzewka „Ogon smoka”, ushiro-, yoko- i mae-ukemi, 3 stacje z rotacją, gry zapaśnicze i ukłon. Ze sprzętem i wskazówkami trenera.'
  },
  {
    src: CDN + '890753f4-628c-4258-abea-1c87c807af94.webp',
    label: 'Tom 1 · Karta zajęć do druku',
    title: 'Zajęcia 1: plan czasu i mapa 3 stacji',
    text: 'Sześć bloków czasowych, rozstawienie stacji A–C na macie i strefa powitania. Do tego słowa-klucze, 3 poziomy trudności i zasady bezpieczeństwa.'
  },
  {
    src: CDN + '42506766-7167-40fb-bbac-b6105ccc576f.webp',
    label: 'Tom 1 · Organizacja maty',
    title: 'Mapa maty ze stacjami',
    text: 'Gdzie ustawić stacje ukemi, techniki w parach i gier w parterze, ile par na stację, jaki sprzęt i dla którego poziomu – plus miejsce trenera i zasada jednego kierunku upadków.'
  }
];
